import { render, staticRenderFns } from "./classSec.vue?vue&type=template&id=f1dc0058&scoped=true&"
import script from "./classSec.vue?vue&type=script&lang=js&"
export * from "./classSec.vue?vue&type=script&lang=js&"
import style0 from "./classSec.vue?vue&type=style&index=0&id=f1dc0058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1dc0058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
